import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { getFormValues, change } from 'redux-form';
import every from 'lodash/every';
import get from 'lodash/get';
import ProductsTable from '../components/ProductsTable';
import withLoadingList from '../../../../common/hoc/withLoaingList';
import { withFormName } from '../../../../common/hoc/withFormName';

export default compose(
  withLoadingList(
    props => props.products,
    () => null,
  ),
  withFormName,
  connect((state, props) => ({
    formValues: getFormValues(props.form)(state),
  }), { changeField: change }),
  withProps(props => ({
    allSelected: every(props.products, product => get(props.formValues, ['products', product.id])),
  })),
  withHandlers({
    onProductToggleSelect: props => productId => (e) => {
      props.changeField(props.form, `products.${productId}`, e.target.checked);
    },
    setAllSelected: props => (value) => {
      const productsSelection = props.products.reduce(
        (products, product) => ({ ...products, [product.id]: value }),
        get(props.formValues, 'products'),
      );
      props.changeField(props.form, 'products', productsSelection);
    },
    isChecked: props => productId => get(props.formValues, ['products', productId]),
  }),
)(ProductsTable);
